module.exports = __webpack_public_path__ + "static/media/BoisLogo.9a03998c.png";